/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colour Contrast Checker (WCAG AA/AAA) — Toolverse`)
};

const es_cc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor de casos — UPPERCASE, camelCase, snake_case y Más | Toolverse`)
};

const de_cc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case Converter — UPPERCASE, camelCase, snake_case & More | Toolverse`)
};

const nl_cc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaakconverter — HOOFDLETTERS, camelCase, snake_case & meer | Toolverse`)
};

const fr_cc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de casse — UPPERCASE, camelCase, snake_case & Plus | Toolverse`)
};

const it_cc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di Case — UPPERCASE, camelCase, snake_case e Altro | Toolverse`)
};

const pt_br2_cc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Caso — UPPERCASE, camelCase, snake_case & Mais | Toolverse`)
};

const pt_cc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Casos — MAIÚSCULAS, camelCase, snake_case e Mais | Toolverse`)
};

const ja_cc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケースコンバーター — UPPERCASE、camelCase、snake_case など | Toolverse`)
};

const zh_cc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大小写转换器 — UPPERCASE、camelCase、snake_case 及更多 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_meta_title", locale)
	if (locale === "en") return en_cc_meta_title(inputs)
	if (locale === "es") return es_cc_meta_title(inputs)
	if (locale === "de") return de_cc_meta_title(inputs)
	if (locale === "nl") return nl_cc_meta_title(inputs)
	if (locale === "fr") return fr_cc_meta_title(inputs)
	if (locale === "it") return it_cc_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_cc_meta_title(inputs)
	if (locale === "pt") return pt_cc_meta_title(inputs)
	if (locale === "ja") return ja_cc_meta_title(inputs)
	return zh_cc_meta_title(inputs)
};